module.exports = __webpack_public_path__ + "fd7e7e01e168775c700ba8597212beb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-4.png
// module id = 1114
// module chunks = 1